/* Replace parseInt with parseFloat Nov 4, 2023 */
/* Add min-height to table Nov 24, 2023 */
/* Remove teamMemberId from fn_checkInvalid Feb 29, 2024 */
/* Add Time Allocation May 10, 2025 */
/* Amend remove py5 and add btn-bar  Apr 11, 2026 */
/* StaffingPeriods child rows displayed as-is; no client grouping  Oct 16, 2026 */
/* Daily rate × working days × allocation %; cost stays editable  Oct 15, 2026 */
/* Keep End date and Delete inside the viewport  Oct 15, 2026 */
<template>
<div class="create-staffing-root">
 <strong>Create Project staffing</strong>
  <b-container class="create-staffing" style="padding-left:0px; margin-left: 0px;">
    <b-form >
		<b-table id="staffingDataTable" table-class="resizable create-staffing-table"  thead-class="staffTable" sticky-header="700px" show-empty :empty-html="c_tableEmpty" small responsive select-mode="single" head-variant="light" :fields="d_headers" :items="c_pagedRows">
        <template #cell(roleId)="data">
            <b-form-select
             class="styled-input role-select"
              :value="data.item.roleId"
              :options="userRoles"
			  @change="m_setRole(data.item, $event)"
              required>
            </b-form-select>
        </template>
        <template #cell(members)='data'>
            <div class="team-member-item">
				<kt-select
						p_appEntKey="team"
						id="teamMemberId"
						:p_currentVal="m_teamMemberVal(data.item)"
						:p_readOnly="p_mode=='view'"
						:p_enableCreate="false"
						p_class="Noborders"
						p_placeholder="Search Team Members"
						@change="m_setTeamMember(data.item, $event)">
				</kt-select>
            </div>
        </template>
        <template #cell(rate)="data">
          <div class="d-flex">
		    <b-input-group size="sm" prepend="$">
             <b-form-input
              id="rate"
			  class="styled-input rate-input"
			  title="Rate per hour"
              placeholder="Rate"
              :value="data.item.rate"
              type="number"
              :formatter="m_numberFormat"
			  @input="m_setRate(data.item, $event)"
              required>
             </b-form-input>
		   </b-input-group>
		  </div>
        </template>
        <template #cell(cost)="data">
          <div class="d-flex">
			<b-input-group size="sm" prepend="$">
            <b-form-input
              id="cost"
			  class="styled-input cost-input"
              placeholder="Cost"
              :value="data.item.cost == null ? '' : data.item.cost"
              type="number"
              step="0.01"
			  @input="m_setCost(data.item, $event)">
            </b-form-input>
			</b-input-group>
		  </div>
        </template>
        <template #head(periods)>
			<div class="period-col-headers">
				<span class="period-h period-h-alloc">Allocation</span>
				<span class="period-h period-h-precon" title="Preconstruction assignment for this period">Precon?</span>
				<span class="period-h period-h-start">Start</span>
				<span class="period-h period-h-end">End</span>
				<span class="period-h period-h-remove"></span>
			</div>
        </template>
        <template #cell(periods)="data">
			<div class="period-list">
				<div
					v-for="period in m_activePeriods(data.item)"
					:key="period.staffingPeriodId || period.id || period._uid"
					class="period-row"
				>
					<div class="period-field period-alloc">
					   <b-input-group size="sm" append="%">
						<b-form-input
							class="styled-input period-input-alloc"
							:value="period.timePercent"
							type="number"
							@input="m_setPeriodField(data.item, period, 'timePercent', $event)"
						/>
					   </b-input-group>
					</div>
					<label class="period-precon" title="Preconstruction assignment for this period">
						<input
							type="checkbox"
							:checked="!!period.precon"
							@change="m_setPeriodField(data.item, period, 'precon', $event.target.checked)"
						/>
					</label>
					<div class="period-field period-start">
						<b-form-input
							class="styled-input period-input-date"
							:class="{ 'date-empty': !period.startDate }"
							:value="period.startDate"
							type="date"
							required
							@input="m_setPeriodField(data.item, period, 'startDate', $event)"
						/>
					</div>
					<div class="period-field period-end">
						<b-form-input
							class="styled-input period-input-date"
							:class="{ 'date-empty': !period.endDate }"
							:value="period.endDate"
							type="date"
							required
							@change="m_validatePeriodEndDate(period, $event)"
							@input="m_setPeriodField(data.item, period, 'endDate', $event)"
						/>
					</div>
					<span class="period-remove-slot">
						<fa-icon
							v-if="m_activePeriods(data.item).length > 1"
							icon="trash-alt"
							size="xs"
							title="Remove period"
							class="cursor-pointer period-remove"
							@click="m_removePeriod(data.item, period)"
						/>
					</span>
				</div>
				<b-button
					size="sm"
					variant="none"
					class="btn-add-period"
					title="Add allocation period"
					@click="m_addPeriod(data.item)"
				>
					<fa-icon icon="plus" class="text-primary"/> Add period
				</b-button>
			</div>
        </template>
        <template v-slot:cell(delete)="data">
			<fa-icon
            icon="trash-alt"
			size="xs"
            @click="m_handleRemoveRow(data.item)"
            class="cursor-pointer role-remove"
			title="Delete role"
          />
        </template>
       <template #custom-foot>
        <b-tr>
          <b-td>
			<b-dropdown variant="outline-secondary" :lazy="true"  dropup  :text="d_perPage.toString()">
				<b-dropdown-item v-for="x in [5,10,25,50,100,150,200]" :key="x"  @click="m_chgPgSize(x)"> {{x}}</b-dropdown-item>
			</b-dropdown>
			rows per page
		</b-td>
          <b-td>Totals:{{c_totalRows}}</b-td>
          <b-td></b-td>
          <b-td>
              <b-input-group prepend="$" class="mb-2 mr-sm-2 mb-sm-0">
				<b-form-input
					id="inline-form-input-total"
					placeholder="Calculated Cost"
					:value="m_costFormat(c_calculateTotalCost)"
					type="text"
					disabled>
                  </b-form-input>
				</b-input-group>
          </b-td>
			<b-td>
				<b-pagination
					v-model="d_currentPage"
					align="right"
					:total-rows="c_totalRows"
					:per-page="d_perPage"
					aria-controls="staffingData">
				</b-pagination>
			</b-td>
			<b-td class="delete-td"></b-td>
        </b-tr>
      </template>
      </b-table>
	  <div class="btn-bar">
		<b-button class="btn-add btn-add-cl-item" variant="none" title="Add role" @click="m_handleAddClick">
			<fa-icon icon="plus" />
          Add Role
		</b-button>
		<b-button class="btn-save"   variant="none" title="Save" @click="m_saveRows">
			<fa-icon icon="save" />
         Save
		</b-button>
	  </div>
      <div class="col-12 align-items-center justify-content-center">
        <div class="row align-items-center">
          <div class="col-3"></div>
          <div class="col-3 project-cost-heading">
          </div>
        </div>
      </div>

    </b-form>
  </b-container>
 </div>
</template>
<script src="@/utils/jQuery.resizableColumns.js"></script>
<script>
import {fn_getStaffingData,fn_saveStaffingData} from "@/utils/api.js";
import util, {kbdpAlert} from "@/utils/util.js";
import {refData} from "@/utils/ref-data.js";
import {fn_validate} from "@/utils/appValidations.js";
import {Resize} from "vue-resizer";

let g_uidSeq = 0;
function fn_nextUid() {
	g_uidSeq += 1;
	return `sd_${Date.now()}_${g_uidSeq}`;
}

export default {
  name: "CreateStaffing",
  components: {"resize":Resize},
  props: {
	p_recordContext:String,
	p_recordId:String,
	p_teamMembers: Array,
	p_staffingData: Array,
  },
  data() {
    return {
		d_currentPage:1,
		d_perPage:5,
		d_selectedRow:null,
		d_validEndDate:null,
		d_endDateToolTip:null,
		selectedResource: null,
		totalCost: 0,
		d_staffingData: [],
      userRoles: [],
      resources: [{ text: "Select Project", value: null, disabled: true }],

      membersData: [],
      d_headers: [
        {label:"Role", key: "roleId",visible:true,thStyle:"width:14%;",tdClass:"role-td",thclass:"resizable"},
        {label:"Team Member",key: "members",visible:true,thStyle:"width:16%;",tdClass:"team-member-td",thclass:"resizable" },
        {label:"Rate", key: "rate",visible:true,thStyle:"width:10%;",tdClass:"rate-td",thclass:"resizable" },
        {label:"Cost", key: "cost",visible:true,thStyle:"width:11%;",tdClass:"cost-td",thclass:"resizable" },
		{label:"", key: "periods",visible:true,thStyle:"",tdClass:"periods-td",thclass:"resizable periods-td"},
		{label:"Delete",key:"delete",visible:true,thStyle:"width:4.8em;",tdClass:"delete-td",thClass:"delete-td no-resize"},
      ],
    };
  },
	mounted() {

	const headers = document.getElementById("staffingDataTable").querySelectorAll("th");

    headers.forEach((header, index) => {
        header.style.position = "relative";

        if (index < headers.length - 1 && !header.classList.contains("no-resize")) {
            const nextNonResizable = [...headers].slice(index + 1).some(th => th.classList.contains("no-resize"));
            if (!nextNonResizable) {
                const resizer = document.createElement("div");
                resizer.className = "resizer";
                resizer.style.position = "absolute";
                resizer.style.top = "0";
                resizer.style.right = "-3px";
                resizer.style.bottom = "0";
                resizer.style.width = "6px";
                resizer.style.zIndex = "999";
                resizer.style.background = "transparent";
                resizer.style.cursor = "col-resize";

                header.appendChild(resizer);

                let isResizing = false;
                let startX;

                resizer.addEventListener("mousedown", (event) => {
                    isResizing = true;
                    startX = event.pageX;
                    document.addEventListener("mousemove", handleResize);
                    document.addEventListener("mouseup", stopResize);
                });

                function handleResize(event) {
                    if (isResizing) {
                        const newWidth = header.offsetWidth + (event.pageX - startX);
                        header.style.width = `${newWidth}px`;
                        startX = event.pageX;
                    }
                }

                function stopResize() {
                    isResizing = false;
                    document.removeEventListener("mousemove", handleResize);
                    document.removeEventListener("mouseup", stopResize);
                }
            }
        }
    });

    document.addEventListener("mouseup", function() {
        headers.forEach(header => header.classList.remove("resizing"));
    });




	window.addEventListener('beforeunload',
			function (e) {
				kbdpAlert.showErr("Exit page?");
				e.preventDefault();
				e.returnValue = '';
            }
        );


	refData.roles.forEach(r=>{
		var role={text:r.name,value:r.id};
		this.userRoles.push(role);
	})

	this.userRoles.unshift({ text: "Select Role", value: null, disabled: true });

	if(this.p_staffingData && this.p_staffingData.length>0)
		this.m_setStaffingData(this.p_staffingData);
	else this.m_handleAddClick();

  },

  computed: {
	c_validStartDate() {return this.d_staffingData.startDate},
	c_startDateToolTip() {return this.d_startDateToolTip},
	c_validEndDate() {return this.d_validEndDate},
	c_endDateToolTip() {return this.d_endDateToolTip},
    c_totalRows(){return this.c_activeRows.length;},
	c_activeRows(){
		return this.d_staffingData.filter(row => !row.removed || row.removed == 0);
	},
	c_pagedRows(){
		const start = (this.d_currentPage - 1) * this.d_perPage;
		return this.c_activeRows.slice(start, start + this.d_perPage);
	},
    c_calculateTotalCost() {
		// Sum of role costs (each period: daily rate × working days × allocation %, unless typed)
		let totalCost = 0;
		this.c_activeRows.forEach(row => {
			const cost = row.costManual ? row.cost : fn_groupCost(row.rate, this.m_activePeriods(row));
			if (cost != null && cost !== '' && !isNaN(parseFloat(cost))) {
				totalCost += parseFloat(cost);
			}
		});
		return fn_roundMoney(totalCost);
    },
	c_tableEmpty(){return '<span style="float:left"><b>No records.<b></span>'},
  },
  methods: {
	m_blankPeriod(){
		return {
			_uid: fn_nextUid(),
			startDate: null,
			endDate: null,
			timePercent: null,
			precon: false,
			removed: 0,
		};
	},
	m_activePeriods(row){
		return ((row && row.staffingPeriods) || []).filter(p => !p.removed || p.removed == 0);
	},
	m_ensurePeriods(row){
		if (!row._uid) this.$set(row, '_uid', fn_nextUid());
		if (row.removed == null) this.$set(row, 'removed', 0);
		let periods = Array.isArray(row.staffingPeriods) ? row.staffingPeriods
			: Array.isArray(row.StaffingPeriods) ? row.StaffingPeriods
			: null;
		if (!periods) {
			periods = [this.m_blankPeriod()];
			this.$set(row, 'staffingPeriods', periods);
		} else if (row.staffingPeriods !== periods) {
			this.$set(row, 'staffingPeriods', periods);
		}
		periods.forEach(p => {
			if (p.removed == null) this.$set(p, 'removed', 0);
			if (!p.staffingPeriodId && !p.id && !p._uid) this.$set(p, '_uid', fn_nextUid());
		});
		if (!this.m_activePeriods(row).length) periods.push(this.m_blankPeriod());
	},
	m_setStaffingData(rows){
		this.d_staffingData = rows || [];
		this.d_staffingData.forEach(row => {
			this.m_ensurePeriods(row);
			this.m_syncRowCost(row);
		});
	},
	m_roleAlreadyUsed(roleId, exceptRow){
		if (roleId == null || roleId === '') return false;
		return this.c_activeRows.some(row =>
			row !== exceptRow && row.roleId != null && String(row.roleId) === String(roleId)
		);
	},
	m_setRole(row, roleId){
	    /*
		if (this.m_roleAlreadyUsed(roleId, row)) {
			kbdpAlert.showErr('Each project role can only be used once. Add allocation periods under the existing role instead.');
			return;
		}
		*/
		
		this.$set(row, 'roleId', roleId);
	},
	m_teamMemberVal(row){
		if (!row) return null;
		if (row.teamMember) return row.teamMember;
		if (!row.teamMemberId && !row.teamMemberName) return null;
		return {
			teamMemberId: row.teamMemberId,
			teamMemberName: row.teamMemberName,
			teamMemberNo: row.teamMemberNo,
		};
	},
	m_setTeamMember(row, member){
		const selected = member && (member.teamMemberId || member.id || member.recId) ? member : null;
		this.$set(row, 'teamMember', selected);
		this.$set(row, 'teamMemberId', selected && (selected.teamMemberId || selected.id || selected.recId) || null);
		this.$set(row, 'teamMemberName', selected && (selected.teamMemberName || selected.name || selected.recName) || null);
	},
	m_setRate(row, rate){
		this.$set(row, 'rate', rate);
		this.$set(row, 'costManual', false);
		this.m_syncRowCost(row);
	},
	m_setCost(row, value){
		const empty = value === '' || value == null;
		if (empty) {
			this.$set(row, 'costManual', false);
			this.m_syncRowCost(row);
			return;
		}
		this.$set(row, 'costManual', true);
		this.$set(row, 'cost', fn_roundMoney(parseFloat(value)));
	},
	m_syncRowCost(row){
		if (!row || row.costManual) return;
		this.$set(row, 'cost', fn_groupCost(row.rate, this.m_activePeriods(row)));
	},
	m_setPeriodField(row, period, field, value){
		if (!period) return;
		this.$set(period, field, value);
		if (field === 'startDate' || field === 'endDate' || field === 'timePercent') {
			this.$set(row, 'costManual', false);
			this.m_syncRowCost(row);
		}
	},
	m_validatePeriodEndDate(period, endVal){
		if (!period || !period.startDate || !endVal) return;
		const startDate = new Date(period.startDate);
		const endDate = new Date(endVal);
		this.d_endDateToolTip = "";
		if (endDate < startDate) {
			this.d_endDateToolTip = "Invalid End date, should be after Start Date";
			kbdpAlert.showErr("Invalid End date, should be after Start Date");
		}
	},
	m_addPeriod(row){
		this.m_ensurePeriods(row);
		row.staffingPeriods.push(this.m_blankPeriod());
		this.$set(row, 'costManual', false);
		this.m_syncRowCost(row);
	},
	m_isNewPeriod(period){
		if (!period) return true;
		return !Object.keys(period).some(k => k !== '_uid' && /(id|Id)$/.test(k) && period[k]);
	},
	m_removePeriod(row, period){
		if (this.m_activePeriods(row).length <= 1) return;
		if (!this.m_isNewPeriod(period)) {
			this.$set(period, 'removed', 1);
		} else {
			const idx = row.staffingPeriods.indexOf(period);
			if (idx >= 0) row.staffingPeriods.splice(idx, 1);
		}
		this.$set(row, 'costManual', false);
		this.m_syncRowCost(row);
	},
	m_validateEndDate(e,idx){
				var startDate= new Date(this.d_staffingData[idx].startDate);
				var endDate= new Date(e);
				this.d_endDateToolTip="";
				if(endDate<startDate){
							this.d_endDateToolTip="Invalid End date, should be after Start Date";
							kbdpAlert.showErr("Invalid End date, should be after Start Date");
                        }
		},
     m_chgPgSize(x){
		this.d_perPage=x;
		this.d_currentPage=1;
	},
     m_onRowSelected(row){
     if(row.length>0){
		this.d_selectedRow=row[0];
		}
     },
     m_numberFormat(value) {
        return value === 0 ? '' : value.toLocaleString('en');
      },
	m_costFormat(value) {
		if (value == null || value === '' || isNaN(parseFloat(value))) return '';
		// Money display: commas + exactly 2 decimals (standard half-up rounding)
		return Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});
	},
	m_saveRows(e){

		let msg = fn_checkInvalid(this);
			if (msg) {
				if (e && e.preventDefault) e.preventDefault();
				kbdpAlert.showErr(msg);
				return;
			}
			else {
				kbdpAlert.clear();
			}

		var params={
			recordContext:this.p_recordContext,
			recordId:this.p_recordId,
			recordData:JSON.stringify(this.m_payloadStaffingData())
			};

	fn_saveData(this,params);
	},
	m_payloadStaffingData(){
		// Refresh calculated costs, then send each role with its staffingPeriods child rows
		this.d_staffingData.forEach(row => this.m_syncRowCost(row));
		const recordType=this.p_recordContext==='projectId'?'project'
			:this.p_recordContext==='opportunityId'?'opportunity':null;
		return this.d_staffingData.map(row => {
			const { _uid, _groupId, costManual, StaffingPeriods, ...rest } = row;
			rest.staffingPeriods = (row.staffingPeriods || []).map(p => {
				const { _uid: periodUid, ...period } = p;
				return period;
			});
			if(recordType){
				rest.recordType=recordType;
				rest.recordContext=this.p_recordContext;
			}
			return rest;
		});
	},
    m_handleAddClick() {
		this.d_staffingData.push({
			_uid: fn_nextUid(),
			staffingDataId: null,
			roleId: null,
			teamMemberId: null,
			teamMember: null,
			teamMemberName: null,
			rate: null,
			cost: null,
			removed: 0,
			staffingPeriods: [this.m_blankPeriod()],
		});
		// Jump to last page so the new role is visible
		this.$nextTick(() => {
			const pages = Math.max(1, Math.ceil(this.c_totalRows / this.d_perPage));
			this.d_currentPage = pages;
		});
	},
    m_handleRemoveRow(row) {

	let content = {
		titleText: 'Confirm Delete',
		message1:`Are you sure you want to delete the record?`,
		message2:`Please be aware that once deleted,you will not be able to undo delete.`,
	};

	let cm = util.fn_getModal_confirm(this, content);

	this.$bvModal.msgBoxConfirm(cm.msgVNodes, cm.opt).then((resp) => {
	if (!resp) return;

	if (row.staffingDataId) {
		this.$set(row, 'removed', 1);
		(row.staffingPeriods || []).forEach(p => {
			this.$set(p, 'removed', 1);
		});
	} else {
		const idx = this.d_staffingData.indexOf(row);
		if (idx >= 0) this.d_staffingData.splice(idx, 1);
	}

	var params={
			recordContext:this.p_recordContext,
			recordId:this.p_recordId,
			recordData:JSON.stringify(this.m_payloadStaffingData())
			};

	fn_deleteData(this,params);

	  });
    },
  },
  watch: {
    projects() {
      if (this.projects.length > 0) {
        let tempProjects = [
          { text: `Select ${this.type}`, value: null, disabled: true },
        ];
        this.projects.forEach((project) => {
          tempProjects.push({
            text: project.projectName,
            value: project.projectId,
          });
        });
        this.resources = tempProjects;
      } else {
        this.resources = [
          { text: `Select ${this.type}`, value: null, disabled: true },
        ];
      }
    },
	p_staffingData(nv){
		if (nv && nv.length) this.m_setStaffingData(nv);
		else if (!this.d_staffingData.length) this.m_handleAddClick();
		},
	p_teamMembers(nv,ov){
      if (nv.length > 0) {
        let tempMembers = [];
        nv.forEach((member) => {
          tempMembers.push({
            name: member.teamMemberName,
            id: member.teamMemberId,
          });
        });
        this.membersData = tempMembers;
      } else {
        this.membersData = [];
      }
	}
  },
};
/** Parse YYYY-MM-DD (or Date) as a local calendar day — avoids UTC off-by-one. */
function fn_parseDateOnly(val) {
	if (!val) return null;
	if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}/.test(val)) {
		const [y, m, d] = val.slice(0, 10).split('-').map(Number);
		return new Date(y, m - 1, d);
	}
	const dt = new Date(val);
	if (isNaN(dt.getTime())) return null;
	return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
}
/** Inclusive Mon–Fri count between start and end; 0 if missing/invalid. */
function fn_countWeekdays(startDate, endDate) {
	const cur = fn_parseDateOnly(startDate);
	const last = fn_parseDateOnly(endDate);
	if (!cur || !last || last < cur) return 0;
	let count = 0;
	while (cur <= last) {
		const day = cur.getDay();
		if (day !== 0 && day !== 6) count++;
		cur.setDate(cur.getDate() + 1);
	}
	return count;
}
/** Round money to 2 decimal places (avoids float artifacts like 24443.9999995). */
function fn_roundMoney(n) {
	if (n == null || isNaN(n)) return null;
	return Math.round((n + Number.EPSILON) * 100) / 100;
}
/** periodCost = daily rate × Mon–Fri days × allocation percent (timePercent is 0–100). */
function fn_periodCost(rate, period) {
	if (rate == null || rate === '' || isNaN(parseFloat(rate))) return null;
	if (!period) return null;
	const weekdays = fn_countWeekdays(period.startDate, period.endDate);
	if (!weekdays) return null;
	const pct = period.timePercent||100;
	const hoursPerDay = 8.00;
	if (pct == null || pct === '' || isNaN(parseFloat(pct))) return null;
	return fn_roundMoney(parseFloat(rate) * weekdays * hoursPerDay * (parseFloat(pct) / 100));
}
function fn_groupCost(rate, periods) {
	if (!periods || !periods.length) return null;
	let total = 0;
	let any = false;
	periods.forEach(p => {
		const c = fn_periodCost(rate, p);
		if (c != null && !isNaN(c)) {
			total += c;
			any = true;
		}
	});
	return any ? fn_roundMoney(total) : null;
}
function fn_checkInvalid(vc){

	const rows = vc.c_activeRows;
	if (!rows.length) {
		return 'Please add at least one project role.';
	}

	const roleCounts = {};
	rows.forEach(row => {
		if (row.roleId == null || row.roleId === '') return;
		const k = String(row.roleId);
		roleCounts[k] = (roleCounts[k] || 0) + 1;
	});
	const dupRole = Object.keys(roleCounts).find(k => roleCounts[k] > 1);
	if (dupRole) {
		const roleLabel = (vc.userRoles.find(r => String(r.value) === String(dupRole)) || {}).text || dupRole;
		return `Role "${roleLabel}" is used more than once. Keep one row per role and add multiple allocation periods under it.`;
	}

	for (let gi = 0; gi < rows.length; gi++) {
		const row = rows[gi];
		const invalid = [];
		if (!row.roleId) invalid.push('Role');
		if (row.rate == null || row.rate === '' || isNaN(parseFloat(row.rate)) || parseFloat(row.rate) < 0) {
			invalid.push('Rate');
		}
		const periods = vc.m_activePeriods(row);
		if (!periods.length) invalid.push('Allocation period');
		periods.forEach((p, pi) => {
			if (p.timePercent == null || p.timePercent === '' || isNaN(parseFloat(p.timePercent)) || parseFloat(p.timePercent) < 0) {
				invalid.push(`Period ${pi + 1} Allocation`);
			}
			if (!p.startDate) invalid.push(`Period ${pi + 1} Start Date`);
			if (!p.endDate) invalid.push(`Period ${pi + 1} End Date`);
			if (p.startDate && p.endDate && new Date(p.startDate) > new Date(p.endDate)) {
				invalid.push(`Period ${pi + 1} End Date`);
			}
		});
		if (invalid.length) {
			return `For role row ${gi + 1} please enter a valid value for the following field(s):\n"` +
				[...new Set(invalid)].join('"\n"') + '"';
		}
	}
	return null;
}
function fn_deleteData(vc,params) {

	kbdpAlert.showSaving('Deleting Staffing Data');

	fn_saveStaffingData(params).then(resp => {
		if (resp.error || resp.errorMessage) {
			let msg = `Unable to delete Staffing Data ` + (resp.error || "");
			kbdpAlert.showErr(msg);
			return;
		}
		else {
			kbdpAlert.clear();
		}
		kbdpAlert.showOk('Staffing Data deleted successfully');
	});
}

function fn_saveData(vc,params) {

	kbdpAlert.showSaving('Staffing Data');
	fn_saveStaffingData(params).then(resp => {
		if (resp.error || resp.errorMessage) {
			let msg = `Unable to save Staffing Data ` + (resp.error || "");
			kbdpAlert.showErr(msg);
			return;
		}
		else {
			kbdpAlert.clear();
		}
		kbdpAlert.showOk('Staffing Data saved successfully');
	//Refresh data
	fn_getStaffingData({recordContext:vc.p_recordContext, recordId:vc.p_recordId})
	.then(resp => {

					console.log('resp');
					console.log(resp);
					vc.m_setStaffingData(resp.staffingData || []);
				});
	})
}
</script>

<style scoped lang="scss">
/* Table stays inside the panel so End and Delete remain on screen */
.create-staffing-root {
  max-width: 100%;
}
::v-deep .table-responsive {
  max-width: 100%;
}
::v-deep table.create-staffing-table {
  width: 100%;
  min-width: 0;
  table-layout: fixed;
}
label {
  font-weight: 600 !important;
}
*:focus {
  box-shadow: none !important;
  outline: none !important;
}

.input-group-text {
  height: 100% !important;
  border-radius: 0.375rem 0px 0px 0.375rem !important;
}
.b-icon.bi {
  color: #ffc107 !important;
}
.table td {
  border: none !important;
  vertical-align: top !important;
}

.small-td {
  width: 100px !important;
}
.large-td {
  width: 300px !important;
}

p {
  margin-left: 20px !important;
  color: #42b983 !important;
  font-weight: 600 !important;
}

.input-group {
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100%;
}
/* Columns share the panel width; inner controls shrink instead of forcing a scrollbar */
.role-td,
.team-member-td,
.rate-td,
.cost-td,
.periods-td,
.delete-td {
  min-width: 0 !important;
  max-width: none !important;
}
.role-select {
  width: 100%;
  min-width: 0;
}
.rate-td .d-flex,
.cost-td .d-flex {
  min-width: 0;
  max-width: 100%;
}
.rate-input,
.cost-input {
  width: 1% !important;
  min-width: 0 !important;
  max-width: none !important;
  flex: 1 1 auto;
}
.table td.delete-td {
  width: 4.8em !important;
  text-align: center;
  box-sizing: border-box;
  vertical-align: middle !important;
}
/* Team Member fills its column; overflow visible so kt-select dropdown is not clipped */
.team-member-td {
  overflow: visible;
}
.team-member-item {
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
  overflow: visible;
  position: relative;
  z-index: 1;

  ::v-deep .kt-select {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0;
    display: flex;
    align-items: stretch;
  }
  /* flex:1 only — width 100% here sits beside the avatar and spills into Rate */
  ::v-deep .sel-cont {
    flex: 1 1 auto;
    width: auto !important;
    min-width: 0 !important;
    max-width: 100%;
    position: relative;
    overflow: visible;
  }
  /* Borderless search box — match rest of app Team Member pickers */
  ::v-deep div.input,
  ::v-deep div.input.Noborders {
    width: 100%;
    max-width: 100% !important;
    box-sizing: border-box;
    overflow: hidden;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    background: transparent !important;
  }
  ::v-deep div.input[open="open"] {
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
  }
  ::v-deep .input-group-text {
    border: none !important;
    background-color: #e9ecef !important;
  }
  ::v-deep div.input-text,
  ::v-deep div.rec-desc {
    display: inline-block !important;
    width: auto !important;
    max-width: 100%;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: bottom;
  }
  ::v-deep div.options-container {
    z-index: 1060;
    min-width: 280px;
  }
}
/* Raise active row so the team-member dropdown paints above neighboring rows */
::v-deep .create-staffing-table tbody tr:hover,
::v-deep .create-staffing-table tbody tr:focus-within {
  position: relative;
  z-index: 4;
}
.team-member-item1 {
  width: 150px !important;

  .multiselect {
    min-height: 38px !important;
    max-height: 100% !important;
    width: 150px !important;
.multiselect__tags {
      height: 30px !important;
      border-radius: 0px !important;
    }
  }
}
.person-fill {
  height: 43px;
}

.project-cost-heading {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.btn-save{
		color:#008000;
		border:none;
		margin-left: 0.1em;;
		margin-right: 0.1em;
}
.btn-add {
		color: #007bff;
		background: transparent !important;
		border: none !important;
		box-shadow: none !important;
		margin-left: 0.1em;
		margin-right: 0.1em;
}
.btn-add:hover,
.btn-add:focus,
.btn-add:active {
		color: #007bff !important;
		background: transparent !important;
		border: none !important;
		box-shadow: none !important;
}
.tableHeader{
			background-color: #6c757d;
			color: #fff;
}
/* Match Competitors Bids header size (th padding 0.1em + thead-light grey); no vertical lines */
::v-deep .create-staffing-table thead.staffTable {
	background-color: #e9ecef !important;
	position: sticky;
	top: 0;
	z-index: 5;
}
::v-deep .create-staffing-table thead.staffTable th {
	background-color: #e9ecef !important;
	color: #495057 !important;
	font-size: 0.875rem !important;
	font-weight: 700 !important;
	letter-spacing: normal;
	text-transform: capitalize;
	padding: 0.35em 0.2em !important;
	vertical-align: middle !important;
	border: none !important;
	border-right: none !important;
	border-bottom: 1px solid #ced4da !important;
	box-shadow: none;
	white-space: nowrap;
}
.cost1{width:50px;}
.teamMemberName1{width: 100px;}
.startDate1{width: 100px;}
.endDate1{width: 100px;}
.role1{width: 100px;}
.resizer {
		position: absolute;
		top: 0em;
		bottom: 0em;
		right: -0.5em;
		width: 1em;
		z-index: 100;
		user-select: none;
		&:hover {
			cursor: ew-resize;
				}
}
.resizing {
	border-right-color: #fff;
	> span.resizer {
		width: 20em;
		right: -10em;
		height: 20em;
		}
}
.kt-select .sel-cont div.input{borders:none !important;}
.btn-bar {
	margin-bottom: 1em;
}
.styled-input,
.styled-select {
  width: 100%;
  border: 0px;
  border-radius: 0px;
  border-bottom: 1px solid #ddd;  //1px solid black;
}
.styled-input:disabled,
.styled-select:disabled {
  background-color: transparent;
  border-bottom: 1px solid #ddd;
}
.styled-input:focus,
.styled-select:focus {
  border-color: transparent;
  border-bottom: 1px solid #428bca;    //1px solid #428bca;
  box-shadow: none;
}
.period-col-headers,
.period-row {
	display: grid;
	/* Allocation, Precon, Start, End, remove — last two date columns share leftover width */
	grid-template-columns: minmax(5.7em, 0.85fr) minmax(4.4em, 0.6fr) minmax(0, 1.2fr) minmax(0, 1.2fr) 1.4em;
	column-gap: 0.45em;
	align-items: center;
	width: 100%;
	min-width: 0;
}
.period-col-headers {
	width: 100%;
	font-weight: 700;
	font-size: 0.875rem;
	letter-spacing: normal;
	text-transform: capitalize;
	line-height: 1.2;
	white-space: nowrap;
	color: inherit;
	align-items: center;
}
.period-h {
	display: flex;
	align-items: center;
	min-height: 1.2em;
	overflow: hidden;
}
.period-h-alloc {
	justify-content: flex-start;
}
.period-h-precon {
	justify-content: flex-start;
	text-align: left;
}
.period-list {
	display: flex;
	flex-direction: column;
	gap: 6px;
	width: 100%;
	min-width: 0;
}
.period-row {
	flex-wrap: nowrap;
}
.period-h,
.period-field,
.period-precon,
.period-remove-slot {
	min-width: 0;
	max-width: 100%;
}
.periods-td,
.period-list,
.period-row,
.period-col-headers {
	overflow: hidden;
}
.period-field {
	display: flex;
	align-items: center;
	gap: 2px;
	min-width: 0;
	overflow: hidden;
}
.period-alloc {
	width: 100%;
}
.period-input-alloc {
	width: 100%;
	min-width: 0;
	max-width: 4.2em;
}
.period-input-date {
	width: 100%;
	min-width: 0;
	max-width: 100%;
	font-size: 0.8rem;
	padding-left: 0.1rem;
	padding-right: 0;
}
/* Hide the browser mm/dd/yyyy hint until a date is chosen; keep the calendar icon */
::v-deep .period-input-date.date-empty::-webkit-datetime-edit,
::v-deep .period-input-date.date-empty::-webkit-datetime-edit-fields-wrapper,
::v-deep .period-input-date.date-empty::-webkit-datetime-edit-text,
::v-deep .period-input-date.date-empty::-webkit-datetime-edit-month-field,
::v-deep .period-input-date.date-empty::-webkit-datetime-edit-day-field,
::v-deep .period-input-date.date-empty::-webkit-datetime-edit-year-field {
	color: transparent;
}
.period-precon {
	display: inline-flex;
	align-items: center;
	justify-content: flex-start;
	margin: 0;
	cursor: pointer;
	user-select: none;
}
.period-precon input {
	margin: 0;
	cursor: pointer;
}
.period-remove-slot {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-height: 1em;
}
.period-remove {
	margin: 0;
	font-size: 0.75rem;
	color1: #868e96;
	color:red;
	opacity: 0;
}
.period-row:hover .period-remove,
.period-row:focus-within .period-remove {
	opacity: 1;
}
.period-remove:hover {
	color1: #dc3545;
	color: green;
}
.role-remove {
	font-size1: 0.85rem;
	color:red;
}
.role-remove:hover {
	color: green;
}
.btn-add-period {
	align-self: flex-start;
	margin-top: 4px;
	padding: 0.22rem 0.6rem;
	font-size: 13px;
	line-height: 1.2;
	background-color: #fff;
	border:none;
	border1: 1px solid #d5d9dd;
	border-radius1: 0.25rem;
	box-shadow1: 0 2px 3px rgba(0, 0, 0, 0.16);
}
</style>
